import styled from '@emotion/styled'
import { Container } from 'components/layout'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'

export const ArticleContainer = styled(Container)`
	max-width: 900px;
`

export const ArticleTitle = styled.h1`
	padding-top: 16px;
	padding-bottom: 32px;
`

export const ArticleContent = styled.div`
	display: flex;
	justify-content: space-between;
	padding-top: 48px;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		flex-direction: column;
		padding-top: 24px;
	}
`

export const ArticleBody = styled.div`
	display: flex;
	width: 70%;
	word-break: break-word;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
		order: 2;
	}
`

export const ArticleInfo = styled.div`
	display: flex;
	flex-direction: column;
	width: 20%;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
		margin-bottom: 24px;
	}
`

export const ArticleSocial = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	width: 10%;
	padding-right: 30px;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
		flex-direction: row;
		order: 1;
	}
`

export const ArticleSocialIcons = styled.div`
	position: sticky;
	top: 120px;
	display: flex;
	flex-direction: column;
	align-items: center;
	@media only screen and (max-width: 768px) {
		flex-direction: row;
	}
`

export const Author = styled.span``

export const Date = styled.span`
	margin-top: 8px;
	color: ${COLORS.SPANISH_GRAY};
`

export const Anchor = styled.a`
	margin-bottom: 24px;
	@media only screen and (max-width: 768px) {
		margin-right: 24px;
	}

	svg:hover path {
		fill: ${COLORS.DARK_ORCHID_PURPLE} !important;
	}
`

export const Tooltip = styled.div`
	position: relative;

	.tooltiptext {
		visibility: hidden;
		width: 140px;
		background-color: #555;
		color: #fff;
		text-align: center;
		border-radius: 6px;
		padding: 5px;
		position: absolute;
		z-index: 1;
		bottom: 150%;
		left: 50%;
		margin-left: -75px;
		opacity: 0;
		transition: opacity 0.3s;

		&::after {
			content: '';
			position: absolute;
			top: 100%;
			left: 50%;
			margin-left: -5px;
			border-width: 5px;
			border-style: solid;
			border-color: #555 transparent transparent transparent;
		}
	}

	&:hover {
		.tooltiptext {
			visibility: visible;
			opacity: 1;
		}
	}
`

export const ProgressBar = styled.div`
	width: 0;
	height: 4px;
	background-color: ${COLORS.SAFETY_ORANGE};
	position: fixed;
	top: 80px;
	left: 0;
	right: 0;
	z-index: 5;
`

export const ArticleImage = styled.div`
	max-height: 300px;
	height: 50vw;
	overflow: hidden;
	border-radius: 8px;
	position: relative;
	img {
		border-radius: 8px;
	}
`
